import {SmallBox} from '@app/components';
import React, {useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {toast} from 'react-toastify';
import Select from 'react-select';
import {useFormik} from 'formik';
import makeAnimated from 'react-select/animated';
import {ContentHeader} from '@components';
import {logoutUser} from '@app/store/reducers/auth';
import {createClient} from '../../services/client';
import {getUserPermission} from '../../utils/helpers';
import {getAllProjectNames} from '../../services/project';
import handleStatus from '../../utils/ajax';

const CreateClient = () => {
  const animatedComponents = makeAnimated();

  const [projects, setProjects] = React.useState([]);
  const [allProject, setAllProject] = React.useState([]);
  const [styleForValidaiton] = React.useState({color: 'red'});
  const user = useSelector((state: any) => state.auth.currentUser);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const initialValues = {
    clientName: '',
    email: '',
    place: '',
    project: [],
    status: true,
    additionalInfo: ''
  };

  const validate = (values: any) => {
    const errors = {} as any;
    if (!values.clientName) {
      errors.clientName = 'Please enter client name';
    }

    if (!values.email) {
      errors.email = 'Please enter client email';
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
    ) {
      errors.email = 'Invalid email address';
    }

    if (!values.place) {
      errors.place = 'Please enter client place';
    }

    if (!values.place) {
      errors.place = 'Please enter client place';
    }

    if (!values.status) {
      errors.status = 'Please select client status';
    }
    if (!values.additionalInfo) {
      errors.additionalInfo = 'Please enter additional information ';
    }

    return errors;
  };

  const onSubmit = async (values: any) => {
    try {
      if (values.status === 'true') {
        formik.values.status = true;
      }
      if (values.status === 'false') {
        formik.values.status = false;
      }

      const payload = {
        clientName: values.clientName,
        email: values.email,
        project: projects.map((project) => project.value),
        additionalInformation: values.additionalInfo,
        place: values.place,
        status: values.status
      };

      const resp = await createClient(payload);
      handleStatus(resp.status, () => dispatch(logoutUser()), navigate);
      if (resp.status === 200) {
        if (resp?.data?.ok) {
          toast(resp?.data?.message);
          navigate('/all-clients');
        }
        toast.warn(resp?.data?.message);
      } else {
        toast.error(resp?.data?.error || 'Error while creating client');
      }
    } catch (error) {
      console.error('Error creating client:', error);
      toast.error('An unexpected error occurred. Please try again later.');
    }
  };

  const formik = useFormik({
    initialValues,
    onSubmit,
    validate
  });

  const getAllProjectNamesFn = async () => {
    const res = await getAllProjectNames();
    if (res.data.ok) {
      setAllProject(
        res.data.data.map(({_id: projectId, projectName}: any) => ({
          value: projectId,
          label: projectName
        }))
      );
    }
  };

  useEffect(() => {
    getAllProjectNamesFn();
  }, []);

  // if (
  //   getUserPermission(user) !== 'superadmin' ||
  //   getUserPermission(user) !== 'admin'
  // ) {
  //   return  navigate('/');
  //   }
  // }

  if (
    getUserPermission(user) === 'superadmin' ||
    getUserPermission(user) === 'admin'
  ) {
    return (
      <>
        <ContentHeader title="Create Client" path="/all-clients" />
        <section className="content">
          <div className="row">
            <div className="col-md-12">
              <div className="card card-outline card-info">
                <div className="card-header">
                  <h3 className="card-title">Client Information</h3>
                </div>
                <div className="card-body">
                  {/* <div className="row"> */}
                  <div className="w-100">
                    <div className="card card-primary">
                      <form onSubmit={formik.handleSubmit}>
                        <div className="card-body d-flex flex-column gap-3">
                          <div className="row">
                            <label
                              htmlFor="inputName"
                              className="col-sm-2 col-form-label"
                            >
                              {' '}
                              Client Name
                            </label>
                            <div className="col-sm-10">
                              <input
                                type="text"
                                className="form-control"
                                id="inputName"
                                placeholder="Name"
                                name="clientName"
                                onChange={formik.handleChange}
                                value={formik.values.clientName}
                              />
                              {formik.touched.clientName &&
                              formik.errors.clientName ? (
                                <div style={styleForValidaiton}>
                                  {formik.errors.clientName}{' '}
                                </div>
                              ) : null}
                            </div>
                          </div>
                          <div className="row">
                            <label
                              htmlFor="inputEmail"
                              className="col-sm-2 col-form-label"
                            >
                              Email
                            </label>
                            <div className="col-sm-10">
                              <input
                                type="email"
                                className="form-control"
                                id="inputEmail"
                                placeholder="Email"
                                name="email"
                                onChange={formik.handleChange}
                                value={formik.values.email}
                              />
                              {formik.touched.email && formik.errors.email ? (
                                <div style={styleForValidaiton}>
                                  {formik.errors.email}{' '}
                                </div>
                              ) : null}
                            </div>
                          </div>
                          <div className="row">
                            <label
                              htmlFor="inputPlace"
                              className="col-sm-2 col-form-label"
                            >
                              Place
                            </label>
                            <div className="col-sm-10">
                              <input
                                type="text"
                                className="form-control"
                                id="inputPlace"
                                placeholder="Place"
                                name="place"
                                onChange={formik.handleChange}
                                value={formik.values.place}
                              />
                              {formik.touched.place && formik.errors.place ? (
                                <div style={styleForValidaiton}>
                                  {formik.errors.place}{' '}
                                </div>
                              ) : null}
                            </div>
                          </div>
                          <div className="row">
                            <label
                              htmlFor="inputPlace"
                              className="col-sm-2 col-form-label"
                            >
                              Project
                            </label>
                            <div className="col-sm-10">
                              <Select
                                closeMenuOnSelect={false}
                                components={animatedComponents}
                                defaultValue={[]}
                                isMulti
                                value={projects}
                                onChange={(e: any) => setProjects(e)}
                                options={allProject}
                              />
                            </div>
                          </div>
                          <div className="row">
                            <label
                              htmlFor="inputPlace"
                              className="col-sm-2 col-form-label"
                            >
                              Status
                            </label>
                            <div className="col-sm-10">
                              <select
                                className="form-control"
                                name="status"
                                onChange={formik.handleChange}
                                value={formik.values.status}
                              >
                                <option value="">Select</option>
                                <option value="true">Active</option>
                                <option value="false">Inactive</option>
                              </select>
                              {formik.touched.status && formik.errors.status ? (
                                <div style={styleForValidaiton}>
                                  {formik.errors.status}{' '}
                                </div>
                              ) : null}
                            </div>
                          </div>
                          <div className="row">
                            <label
                              htmlFor="inputSkills"
                              className="col-sm-2 col-form-label"
                            >
                              Additional Information
                            </label>
                            <div className="col-sm-10">
                              <textarea
                                className="form-control"
                                id="inputSkills"
                                placeholder="Information"
                                style={{height: '120px'}}
                                name="additionalInfo"
                                onChange={formik.handleChange}
                                value={formik.values.additionalInfo}
                              />
                              {formik.touched.additionalInfo &&
                              formik.errors.additionalInfo ? (
                                <div style={styleForValidaiton}>
                                  {formik.errors.additionalInfo}{' '}
                                </div>
                              ) : null}
                            </div>
                          </div>
                          <div>
                            <button
                              type="submit"
                              className="btn btn-primary offset-md-2"
                            >
                              Submit
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                  {/* </div> */}
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
};

export default CreateClient;
